// src/hooks/useAlerts.js
import { notification } from "antd";
import { useCallback } from "react";

export const useShowAlert = () => {
  const success = useCallback((message, duration, place) => {
    notification.success({
      duration,
      message,
      placement: place,
    });
  }, []);

  const error = useCallback((message, duration, place) => {
    notification.error({
      duration,
      message,
      placement: place,
    });
  }, []);

  const warning = useCallback((message, duration, place) => {
    notification.warning({
      duration,
      message,
      placement: place,
    });
  }, []);

  return { success, error, warning };
};
